import { App } from 'vue';
import { useStore } from 'vuex';

import { report } from '@/api/tracking';

interface TrackParams {
  eventType: string;
  mid: string;
  clientUrl: string;
  clientUa: string;
  category: Array<any>;
  extra?: any; // 这个参数是动态的，根据业务传参需要来决定
}

// 埋点事件
type eventType = 'pv' | 'mv' | 'mc';

const getCommonTrackParams = () => {
  const store = useStore();
  return {
    clientUrl: window.location.href,
    clientUa: navigator.userAgent,
    category: store?.getters.currentTab,
  };
};

const reportEvent = (type: eventType, mid: string, extra?: any) => {
  const commonParams = getCommonTrackParams();
  const trackPramas: TrackParams = {
    eventType: type,
    mid,
    clientUrl: commonParams.clientUrl,
    clientUa: commonParams.clientUa,
    category: commonParams.category,
  };

  if (type !== 'pv') {
    trackPramas.extra = extra || {};
  }

  // console.log('🚀 ~ reportEvent ~ trackPramas:', trackPramas);
  report(trackPramas);
  // .then(() => {
  //   if (type === 'pv') {
  //     console.log('🚀 ~ LOKI TRACKING PV SUCCESS!', trackPramas);
  //   }
  // })
  // .catch((e: any) => {
  //   if (type === 'pv') {
  //     console.log('🚀 ~ LOKI TRACKING PV FAILED!', e, trackPramas);
  //   }
  // });
};

interface TrackEvents {
  mv: (mid: string, value: any) => void;
  mc: (mid: string, value: any) => void;
}

interface Config {
  trackEvents?: TrackEvents;
}

const defaultTrackEvents = {
  // pv() {
  //   console.log('🚀 ~ pv');
  // },
  mv(mid: string, extra = {}) {
    reportEvent('mv', mid, extra);
  },
  mc(mid: string, extra = {}) {
    reportEvent('mc', mid, extra);
  },
};

class Loki {
  constructor() {
    // nothing
  }

  static install(app: App, { trackEvents }: Config = { trackEvents: defaultTrackEvents }) {
    // 指令用法
    app.directive('track', {
      mounted(el, binding) {
        const { mid, ...other } = binding?.value || {};
        trackEvents?.mv(mid, other);

        if (binding.modifiers.click) {
          el.addEventListener('click', () => trackEvents?.mc(mid, other));
        }
      },
    });
  }

  // pv不带业务参数
  static pv(mid: string) {
    reportEvent('pv', mid);
  }

  // mc可以
  static mc(mid: string, extra = {}) {
    reportEvent('mc', mid, extra);
  }
}

// 挂到window，可以用静态方法
window.$track = Loki;

export default Loki;
